import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withModifiers as _withModifiers, withDirectives as _withDirectives, vModelText as _vModelText } from "vue"

const _hoisted_1 = { id: "wallpaper-buttons" }
const _hoisted_2 = {
  class: "tooltip",
  "data-tooltip": "打开侧边面板"
}
const _hoisted_3 = {
  class: "tooltip",
  "data-tooltip": "收藏当前背景"
}
const _hoisted_4 = {
  class: "tooltip",
  "data-tooltip": "切换当前背景"
}
const _hoisted_5 = { id: "sidebar-buttons" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = {
  key: 1,
  class: "text-list"
}
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { key: 2 }
const _hoisted_10 = {
  key: 3,
  class: "image-list"
}
const _hoisted_11 = ["src", "alt", "onClick"]
const _hoisted_12 = { id: "schedule-config" }
const _hoisted_13 = ["value"]
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { class: "side-bar-input" }
const _hoisted_16 = { id: "sync-status" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SvgIcon = _resolveComponent("SvgIcon")!

  return (_openBlock(), _createElementBlock("aside", {
    ref: "aside",
    class: _normalizeClass(_ctx.showSideBar? 'show' : 'hide')
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("span", _hoisted_2, [
        _createVNode(_component_SvgIcon, {
          name: "Photo",
          size: "16px",
          onClick: _ctx.toggleSideBar
        }, null, 8, ["onClick"])
      ]),
      _createElementVNode("span", _hoisted_3, [
        _createVNode(_component_SvgIcon, {
          name: "Star",
          size: "16px",
          class: _normalizeClass({checked: _ctx.isFavorite()}),
          onClick: _ctx.toggleFavorite
        }, null, 8, ["class", "onClick"])
      ]),
      _createElementVNode("span", _hoisted_4, [
        _createVNode(_component_SvgIcon, {
          name: "ArrowPath",
          size: "16px",
          onClick: _ctx.setWallpaper
        }, null, 8, ["onClick"])
      ])
    ]),
    _createElementVNode("nav", null, [
      _cache[27] || (_cache[27] = _createElementVNode("h2", null, "Vua New Tab", -1)),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("button", {
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.login && _ctx.login(...args))),
          class: "tooltip",
          "data-tooltip": "登录清华云盘"
        }, "登录"),
        _createElementVNode("button", {
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.update && _ctx.update(...args))),
          class: "tooltip",
          "data-tooltip": "刷新显示云盘文件夹"
        }, "刷新"),
        _createElementVNode("button", {
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.deploy && _ctx.deploy(...args))),
          class: "tooltip",
          "data-tooltip": "使用当前文件夹下的图片文件作为背景"
        }, "部署"),
        _createElementVNode("button", {
          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.config && _ctx.config(...args))),
          class: "tooltip",
          "data-tooltip": "在当前文件夹下存放书签"
        }, "书签")
      ]),
      (_ctx.isChromeExt)
        ? (_openBlock(), _createElementBlock("h3", _hoisted_6, "云盘数据"))
        : _createCommentVNode("", true),
      _createElementVNode("small", null, _toDisplayString(_ctx.currentFolder), 1),
      (_ctx.folderContent.length)
        ? (_openBlock(), _createElementBlock("ul", _hoisted_7, [
            (_ctx.folderContentStack.length !== 0)
              ? (_openBlock(), _createElementBlock("li", {
                  key: 0,
                  onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)))
                }, ".."))
              : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.folderContent, (item) => {
              return (_openBlock(), _createElementBlock("li", {
                key: item.id,
                onClick: ($event: any) => (_ctx.goForward(item))
              }, [
                _createVNode(_component_SvgIcon, {
                  name: _ctx.icons[item.type],
                  size: "16px"
                }, null, 8, ["name"]),
                _createElementVNode("div", null, _toDisplayString(item.name), 1)
              ], 8, _hoisted_8))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      (_ctx.isChromeExt)
        ? (_openBlock(), _createElementBlock("h3", _hoisted_9, "收藏预览"))
        : _createCommentVNode("", true),
      (_ctx.isChromeExt && _ctx.showSideBar)
        ? (_openBlock(), _createElementBlock("ul", _hoisted_10, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.viewList, (item) => {
              return (_openBlock(), _createElementBlock("li", { key: item }, [
                _createElementVNode("img", {
                  src: item,
                  alt: _ctx.getNameFromThumbnail(item),
                  onClick: ($event: any) => (_ctx.setFromFavorite(item))
                }, null, 8, _hoisted_11)
              ]))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      _cache[28] || (_cache[28] = _createElementVNode("h3", null, "壁纸设置", -1)),
      _createElementVNode("div", _hoisted_12, [
        _cache[22] || (_cache[22] = _createElementVNode("h4", null, "壁纸配置同步", -1)),
        _withDirectives(_createElementVNode("select", {
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.wallpaperDataIndex) = $event)),
          onContextmenu: _cache[6] || (_cache[6] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.changeWallpaperDataName && _ctx.changeWallpaperDataName(...args)), ["prevent"])),
          class: "side-bar-input"
        }, [
          _cache[15] || (_cache[15] = _createElementVNode("option", { value: "-1" }, "本地配置", -1)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.wallpaperData, (item, index) => {
            return (_openBlock(), _createElementBlock("option", {
              value: index,
              key: index
            }, _toDisplayString(item.name), 9, _hoisted_13))
          }), 128)),
          _cache[16] || (_cache[16] = _createElementVNode("option", { value: "-2" }, "新建配置", -1))
        ], 544), [
          [_vModelSelect, _ctx.wallpaperDataIndex]
        ]),
        _cache[23] || (_cache[23] = _createElementVNode("h4", null, "自动切换模式", -1)),
        _withDirectives(_createElementVNode("select", {
          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.scheduleMode) = $event)),
          class: "side-bar-input"
        }, _cache[17] || (_cache[17] = [
          _createElementVNode("option", { value: "static" }, "静态壁纸", -1),
          _createElementVNode("option", { value: "newtab" }, "新标签页", -1),
          _createElementVNode("option", { value: "timer" }, "定时切换", -1)
        ]), 512), [
          [_vModelSelect, _ctx.scheduleMode]
        ]),
        (_ctx.scheduleMode === 'timer')
          ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
              _cache[19] || (_cache[19] = _createElementVNode("h4", null, "时间间隔", -1)),
              _withDirectives(_createElementVNode("input", {
                type: "number",
                class: "side-bar-input",
                min: "1",
                max: "60",
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.timeInterval) = $event))
              }, null, 512), [
                [
                  _vModelText,
                  _ctx.timeInterval,
                  void 0,
                  { number: true }
                ]
              ]),
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.scheduleIntervalUnit) = $event)),
                class: "side-bar-input"
              }, _cache[18] || (_cache[18] = [
                _createElementVNode("option", { value: "second" }, "秒", -1),
                _createElementVNode("option", { value: "minute" }, "分", -1),
                _createElementVNode("option", { value: "hour" }, "时", -1),
                _createElementVNode("option", { value: "day" }, "天", -1)
              ]), 512), [
                [_vModelSelect, _ctx.scheduleIntervalUnit]
              ])
            ]))
          : _createCommentVNode("", true),
        _cache[24] || (_cache[24] = _createElementVNode("h4", null, "壁纸来源", -1)),
        _withDirectives(_createElementVNode("select", {
          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.scheduleSource) = $event)),
          class: "side-bar-input"
        }, _cache[20] || (_cache[20] = [
          _createElementVNode("option", { value: "favorite" }, "收藏", -1),
          _createElementVNode("option", { value: "deploy" }, "部署", -1)
        ]), 512), [
          [_vModelSelect, _ctx.scheduleSource]
        ]),
        _cache[25] || (_cache[25] = _createElementVNode("h4", null, "背景模糊", -1)),
        _createElementVNode("div", _hoisted_15, [
          _withDirectives(_createElementVNode("input", {
            type: "range",
            min: "0",
            max: "100",
            step: "1",
            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.wallBlur) = $event)),
            onMouseup: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.saveScheduleData && _ctx.saveScheduleData(...args))),
            onTouchend: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.saveScheduleData && _ctx.saveScheduleData(...args)))
          }, null, 544), [
            [
              _vModelText,
              _ctx.wallBlur,
              void 0,
              { number: true }
            ]
          ]),
          _createElementVNode("div", null, _toDisplayString(_ctx.wallBlur), 1)
        ]),
        _cache[26] || (_cache[26] = _createElementVNode("h4", null, "模糊条件", -1)),
        _withDirectives(_createElementVNode("select", {
          "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.blurCondition) = $event)),
          class: "side-bar-input"
        }, _cache[21] || (_cache[21] = [
          _createElementVNode("option", { value: "always" }, "总是模糊", -1),
          _createElementVNode("option", { value: "focused" }, "聚焦输入", -1)
        ]), 512), [
          [_vModelSelect, _ctx.blurCondition]
        ])
      ]),
      _createElementVNode("small", _hoisted_16, _toDisplayString(_ctx.syncStatus), 1)
    ])
  ], 2))
}